import { render } from "./PayVASummary.vue?vue&type=template&id=5f609a06&scoped=true"
import script from "./PayVASummary.vue?vue&type=script&lang=js"
export * from "./PayVASummary.vue?vue&type=script&lang=js"

import "./PayVASummary.vue?vue&type=style&index=0&id=5f609a06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f609a06"]])

export default __exports__